import React, { useState, useEffect } from 'react';
import {
    Input, Form, TextArea, Radio, PlusOutlined, Select,EditFilled,  useDispatch,useSelector, Button,  message, Tooltip, Popconfirm, Drawer,DownOutlined,UpOutlined,Checkbox,FileAddOutlined,DeleteOutlined, Spin
} from '../AntComponent';
import AddSettings from './modal/AddSettings';
import { getMilestone, saveMilestone, saveProjectTask,saveProjectDeliverable,deleteDeliverable,deleteProjectTask,deleteMilestone } from '../../store/actions/project-management/ProjectAction';
import {  getProjectType } from '../../store/actions/project-management/ProjectSettingAction';
import {getDocumnetType } from '../../store/actions/DocumentManagerAction'

export default function TemplateDetail(props) {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [form1] = Form.useForm();
    const [form2] = Form.useForm();
    const [mileData, setMileData] = useState([]);
    const [taskID, setTaskID] = useState(0);
    const [deliverableID, setDeliverableID] = useState(0);
    const [milestoneID, setMilestoneID] = useState(0);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [projectTypeDrawer, setProjectTypeDrawer] = useState(false);
    const [taskDrawer, setTaskDrawer] = useState(false);
    const [deliverableDrawer, setDeliverableDrawer] = useState(false);
    const [mileInfo, setMileinfo] = useState(null);
    const [taskInfo, setTaskinfo] = useState(null);
    const [deliverableInfo, setDeliverableinfo] = useState(null);
    const { milestoneInfo,saveMileInfo,savetaskInfo, success9, success10, loading9, loading10,loading7,success11,deleteDilInfo,
        saveDilInfo,success12,success13,deletetaskInfo,deleteMileInfo,success14,loading11, success7 } = useSelector((state) => state.project);
    const { typeList,success } = useSelector(state => state.projectSetting);
    const {documentTypes} = useSelector(state => state.documentManager);
    const [showSuccessmsg, setShowsuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success10 : null;
    const [showSuccessmsg1, setShowsuccessmsg1] = useState(false);
    const successmsg1 = showSuccessmsg1 ? success10 : null;
    const [showSuccessmsg2, setShowsuccessmsg2] = useState(false);
    const successmsg2 = showSuccessmsg2 ? success9 : null;
    const [showSuccessmsg3, setShowsuccessmsg3] = useState(false);
    const successmsg3 = showSuccessmsg3 ? success9 : null;
    const [showSuccessmsg4, setShowsuccessmsg4] = useState(false);
    const successmsg4 = showSuccessmsg4 ? success11 : null;
    const [showSuccessmsg5, setShowsuccessmsg5] = useState(false);
    const successmsg5 = showSuccessmsg5 ? success12 : null;
    const [showSuccessmsg6, setShowsuccessmsg6] = useState(false);
    const successmsg6 = showSuccessmsg6 ? success11 : null;
    const [showSuccessmsg7, setShowsuccessmsg7] = useState(false);
    const successmsg7 = showSuccessmsg7 ? success13 : null;
    const [showSuccessmsg8, setShowsuccessmsg8] = useState(false);
    const successmsg8 = showSuccessmsg8 ? success14 : null;
    const [showSuccessmsg9, setShowsuccessmsg9] = useState(false);
    const successmsg9 = showSuccessmsg9 ? success : null;
    const [openSubMenu, setOpenSubMenu] = useState(null);
    const [selectedOption, setSelectedOption] = useState('MileStone');
    const [isDoc, setIsDoc] = useState(false);
    const [initiativeTypeID, setInitiativeTypeID] = useState(0)
    const [defaultTypeID, setDefaultTypeId] = useState(null)
    const [initiativeTypeStatus, setInitiativeTypeStatus] = useState(null)
    const toggleSubMenu = (mileStoneID) => {
        if (openSubMenu === mileStoneID) {
          setOpenSubMenu(null);
        } else {
          setOpenSubMenu(mileStoneID);
        }
    };
    const projectTyList = typeList?.data?.map((item,index) => {
        return (
          {
            label: item.initiativeType,
            value: item.initiativeTypeID,
            key: index
          }
        )
    });
    const getDocumentDatas =()=>{
        if(props.data.tenantID){
          let ids1 = `${props.data.tenantID}/${props.data.locationID}`
         dispatch(getDocumnetType(ids1))
        }
    }
    const documentTypeList = documentTypes?.data?.map((item) =>{
        return{
            label:item.documentType,
            value:item.docTypeID, 
        }
    })
    const handleProjectTypeChange = (e) =>{
        setInitiativeTypeID(e)
        setDefaultTypeId(e)
        const selectedInitiative = typeList?.data?.find(item => item.initiativeTypeID === e);
        if (selectedInitiative) {
            setInitiativeTypeStatus(selectedInitiative.initiativeTypeStatus);
          } else {
            console.error(`Initiative with ID ${e} not found in API data.`);
          }
    }
    useEffect(()=>{
        if(initiativeTypeID !== 0){
            getMilestoneDetails();
        }
    },[initiativeTypeID])
    const handleOptionChange = (e) => {
        setSelectedOption(e.target.value);
    };
    const drawerCallbackFunc = (item) => {
        setProjectTypeDrawer(item);
    }
    const handleIsDoc = (e) => {
        setIsDoc(e.target.checked);
      };
    useEffect(() => {
        if (milestoneInfo?.data) {
            setMileData(milestoneInfo?.data);
        }
    }, [milestoneInfo]);
    useEffect(()=>{
            setMileData([]);
            setDefaultTypeId(null);
            setInitiativeTypeID(null);
            setInitiativeTypeStatus(null);
            setSelectedOption('MileStone');
    },[props.data.tabKey])
    useEffect(() => {
        if (successmsg) {
            if(saveMileInfo?.message == "MileStone Data Creation or Updation is Failed"){
                message.error("Milestone Name Already Exists")
            }
            else{
                message.success("Milestone Added Successfully");
            }
            setShowsuccessmsg(false);
            setOpenDrawer(false);
            getMilestoneDetails();
        }
        if(successmsg1){
            if(saveMileInfo?.data.msg == "Already Exists"){
                message.error("Milestone Name Already Exists")
            }
            else{
                message.success("Milestone Updated Successfully");
            }
            setShowsuccessmsg1(false);
            setOpenDrawer(false);
            getMilestoneDetails();
        } 
    }, [successmsg,successmsg1]);
    useEffect(() => {
        if (successmsg2) {
            if(savetaskInfo?.data?.msg == "Already Exists"){
                message.error("Task Name Already Exists")
            }
            else{
                message.success("Task Added Successfully");
            }
            setShowsuccessmsg2(false);
            setTaskDrawer(false);
            getMilestoneDetails();
        }
        if(successmsg3){
            message.success("Task Updated Successfully");
            setShowsuccessmsg3(false);
            setTaskDrawer(false);
            getMilestoneDetails();
        }     
    }, [successmsg2,successmsg3]);
    useEffect(() =>{
        if(successmsg4){
            if(saveDilInfo?.data?.msg == "Saved Successfully"){
                message.success("Deliverable Added Successfully");
                setShowsuccessmsg4(false);
                setDeliverableDrawer(false);
                getMilestoneDetails();
            }
        } 
        if(successmsg6){
            if(saveDilInfo?.data?.msg == "Already Exists"){
                message.error("Deliverable Name Already Exists");
            }
            else{
                message.success("Deliverable Updated Successfully");
            }
            setShowsuccessmsg6(false);
            setDeliverableDrawer(false);
            getMilestoneDetails();
        }
    },[successmsg4,successmsg6])
    useEffect(() =>{
        if(successmsg5){
            if(deleteDilInfo?.data?.msg == "Deleted Successfully"){
                message.success("Deliverable  Deleted Successfully");
                setShowsuccessmsg5(false);
                getMilestoneDetails();
            }
            else{
                message.error(deleteDilInfo?.data?.msg)
                setShowsuccessmsg5(false);
            }
        }
    },[successmsg5])
    useEffect(() =>{
        if(successmsg7){
            if(deletetaskInfo?.data?.msg == "Deleted Successfully"){
                message.success("Task Deleted Successfully");
                setShowsuccessmsg7(false);
                getMilestoneDetails();
            }
            else{
                message.error(deleteDilInfo?.data?.msg)
                setShowsuccessmsg7(false);
            }
        }
    },[successmsg7])
    useEffect(() =>{
        if(successmsg8){
            if(deleteMileInfo?.data?.msg == "Deleted Successfully"){
                message.success("Milestone Deleted Successfully");
                setShowsuccessmsg8(false);
                getMilestoneDetails();
            }
            else{
                message.error(deleteMileInfo?.data?.msg)
                setShowsuccessmsg8(false);
            }
        }
    },[successmsg8])
    function getMilestoneDetails() {
        let ids = `${props.data.tenantID}/${props.data.locationID}/${initiativeTypeID}/${0}`;
        if (props.data.tenantID &&initiativeTypeID != null ) {
            dispatch(getMilestone(ids));
        }
    }
    function getProjectTypeList() {
        let ids = `${props.data.tenantID}/${props.data.locationID}/0`;
        dispatch(getProjectType(ids));
    }
    useEffect(()=>{
        getProjectTypeList()
    },[dispatch, props.data.tenantID])
    const handleBack = () => {
        props.data.callbackFuncs(false)
        props.data.callbackFunc();
    }
    const openMilestoneDrawer = () => {
        form.resetFields();
        handleOpenDrawer();
        setMilestoneID(0);
        form.setFieldsValue({
            status: "Active"
        })
    }
    const openDeliverableDrawer = () => {
        getDocumentDatas()
        form2.resetFields();
        handleOpenDeliverableDrawer();
        setDeliverableID(0);
        form2.setFieldsValue({
            Dilstatus: "Active"
        })
    }
    const handleOpenDrawer = () => {
        setOpenDrawer(true);
    }
    const handleOpenTaskDrawer = () => {
        setTaskDrawer(true);
    }
    const handleOpenDeliverableDrawer = () => {
        setDeliverableDrawer(true);
    }
    const priorityOptions = [
        {
            key: '1',
            label: "High",
            value: "High"
        },
        {
            key: '2',
            label: "Medium",
            value: "Medium"
        },
        {
            key: '3',
            label: "Low",
            value: "Low"
        }
    ];
    const taskStatusOptions = [
        {
            key: '1',
            value: 'Active',
            label: 'Active',
        },
        {
            key: '2',
            value: 'Hold',
            label: 'On Hold',
        },
        {
            key: '3',
            value: 'Cancel',
            label: 'Cancel',
        },
        {
            key: '4',
            value: 'Complete',
            label: 'Complete',
        },
        {
            key: '5',
            value: 'Archived',
            label: 'Archived',
        },
    ];
    const hanldeCloseDrawer = () => {
        setOpenDrawer(false);
    }
    const hanldeCloseTaskDrawer = () => {
        setTaskDrawer(false);
    }
    const hanldeCloseDeliverableDrawer = () => {
        setDeliverableDrawer(false);
        setIsDoc(false);
    }
    const updateMilestoneDrawer = (item) => {
        handleOpenDrawer();
        setMilestoneID(item.mileStoneID);
        setMileinfo(item);
        getMile(item)
    }
    const onSubmitForm = (values) => {
        let inputJson = {
            "MileStoneID": milestoneID,
            "MileStoneName": values.milestoneName,
            "Description": values.description,
            "StartDate": null,
            "EndDate":  null,
            "Percentage": "100.00",
            "MileStoneComments": values.description,
            "MileStoneStatus": values.status,
            "ProjectID": 0,
            "TenantID": props.data.tenantID,
            "LocationID": props.data.locationID,
            "CreatedBy": props.data.appUserID,
            "InitiativeTypeID": initiativeTypeID,
            "IsMandatory":  values.isMandatoryMil === false || values.isMandatoryMil === null || values.isMandatoryMil === undefined ? false : true,
        }
        dispatch(saveMilestone(inputJson));
        if(milestoneID!==0){
            setShowsuccessmsg1(true);
        }else{
            setShowsuccessmsg(true);
        }
    }
    const savePrjDeliverable = (values) =>{
        const matchingDocumentType = documentTypes?.data?.find(item => item.docTypeID === values.docType);
        const label =  matchingDocumentType?.documentType
        let inputJson ={
            "DeliverableTypeID": deliverableID,
            "DeliverableType": values.deliverableName,
            "Description": values.description,
            "DeliverableTypeStatus": "",
            "InitiativeTypeID": initiativeTypeID,
            "MileStoneID": milestoneID,
            "ProjectID": 0,
            "TenantID": props.data.tenantID,
            "LocationID": props.data.locationID,
            "CreatedBy": props.data.appUserID,
            "IsMandatory":  values.isMandatory === false || values.isMandatory === null || values.isMandatory === undefined ? false : true,
            "IsDocumentType":isDoc,
            "DocTypeID": values.docType,
            "DocumentType":label|| "",
        }
        dispatch(saveProjectDeliverable(inputJson))
        if(deliverableID!==0){
            setShowsuccessmsg6(true);
        }else{
            setShowsuccessmsg4(true);
        }
        setIsDoc(false)
    }
    const deletePrjDeliverable = (value)=>{
        let ids = `${props.data.tenantID}/${value.deliverableTypeID}`;
        dispatch(deleteDeliverable(ids));
        setShowsuccessmsg5(true);
    }
    const deletePrjtask = (value)=>{
        let ids = `${props.data.tenantID}/${value.pTaskID}`;
        dispatch(deleteProjectTask(ids));
        setShowsuccessmsg7(true)
    }
    const deletePrjMilestone = (value)=>{
        let ids = `${props.data.tenantID}/${value.mileStoneID}`;
        dispatch(deleteMilestone(ids));
        setShowsuccessmsg8(true)
    }
    const saveProjecTask = (values) => {
        let val = values;
        let inputJson = {
            "PTaskID": taskID,
            "TaskName": val.taskName,
            "TaskDescription": val.description || "",
            "IsTimeTrack": false,
            "IsBillable": false,
            "EmpIDs":  "",
            "ProjectID": 0,
            "MileStoneID": milestoneID,
            "InitiativeTypeID": initiativeTypeID,
            "EstStartDate": null,
            "EstEndDate": null,
            "ActStartDate": null,
            "ActEndDate": null,
            "EstEffort": 0.00,
            "ActEffort": 0.00,
            "TaskStatus": val.taskStatus,
            "TaskPriority": val.priority,
            "IsProjEstDateExten": false,
            "ProjEstEndDate": null,
            "ReferenceNo": "",
            "TenantID": props.data.tenantID,
            "LocationID": props.data.locationID,
            "CreatedBy": props.data.appUserID,
            // "YearID": props.data.yearID,
            // "GmtDateTime": gmtDate
        }
        dispatch(saveProjectTask(inputJson));
        if(taskID!==0){
            setShowsuccessmsg3(true);
        }else{
            setShowsuccessmsg2(true);
        }
    }
    const getMile = (item) => {
        setMilestoneID(item.mileStoneID);
        form.setFieldsValue({
            milestoneName: item.mileStoneName,
            description: item.mileStoneComments,
            status: item.mileStoneStatus,
            isMandatoryMil: item.isMandatory,
        })
    };
    const getTask = (item) => {
        setTaskID(item.pTaskID);
        form1.setFieldsValue({
            taskName: item.taskName,
            priority: item.taskPriority,
            taskStatus: item.taskStatus,
            description: item.taskDescription
        });
    }
    const getDeliverable = (item) => {
        const matchingDocumentType = documentTypes?.data?.find(val => val.documentType === item.documentType);
        const docTypeValue =  matchingDocumentType?.docTypeID
        setDeliverableID(item.deliverableTypeID);
        form2.setFieldsValue({
            deliverableName: item.deliverableType,
            description: item.description,
            Dilstatus: item.deliverableTypeStatus,
            isMandatory: item.isMandatory,
            isDoc: item.isDocumentType,
            docType: docTypeValue,

        });
        setIsDoc(item.isDocumentType)
    }
    const openTaskDrawer = (sdate, edate, id) => {
        form1.resetFields();
        form.resetFields();
        handleOpenTaskDrawer();
        setTaskID(0);
        setMilestoneID(id);
        form1.setFieldsValue({
            taskStatus: 'Active'
        })
    }
    const updateTaskDrawer = (item, sdate, edate) => {      
        handleOpenTaskDrawer();
        setTaskID(item.pTaskID);
        setMilestoneID(item.mileStoneID);
        setTaskinfo(item);
    }
    const updateDeliverableDrawer = (item) =>{
        getDocumentDatas()
        handleOpenDeliverableDrawer();
        setDeliverableID(item.deliverableTypeID);
        setMilestoneID(item.mileStoneID);
        setDeliverableinfo(item);
    }
    const getParentTableClassName = (mileStoneID) => {
        if (openSubMenu === mileStoneID) {
          return 'parent-table-open';
        }
        return 'bg-white';
      };
      console.log(defaultTypeID, "default")
    return(
        <div className='h-100 p-1'>
            <div className='row m-0 mt-2 mb-2'>
                <h5 className='my-auto col-auto'> Milestone/Templates</h5>
            </div>
            <div className='ptypeDetail m-2 p-2 pt-3 pb-3 mt-3 mb-3 d-flex justify-content-between align-items-ceter'>
                <div className='col-md-8 d-flex align-items-center'>
                    <h6 className='d-inline mb-0'>Project Type: </h6>
                    <div className='d-inline ps-1'>
                        <Select className='prjTypeSelect ' value={defaultTypeID}  onChange={handleProjectTypeChange} options={projectTyList}></Select>
                    </div>
                </div>
                {
                    defaultTypeID !== null &&
                    <div className={`col-md-3 d-flex justify-content-center align-items-center ptype-status ${initiativeTypeStatus == 'InActive' ? "inActive" : ""}`}>
                        <label className='ms-1 text-capitalize '
                        >{initiativeTypeStatus == null ? "-" :initiativeTypeStatus }</label>
                    </div>
                }
            </div>
            <div className='row m-0 h-100 mt-2'>
                <div className='col-md-12 bg-white me-2 p-1 h-100 rounded '>
                    <div className='p-1 project-plan'>
                        <div className='d-flex mb-2'>
                            <div className='template-radio-btn mb-3'>
                                <Radio.Group onChange={handleOptionChange} value={selectedOption}>
                                    <Radio value="MileStone">Milestone / Task</Radio>
                                    <Radio value="Deliverable"> Deliverables</Radio>
                                </Radio.Group>
                            </div>
                            {
                                selectedOption == 'MileStone' && 
                                <div onClick={() => openMilestoneDrawer()} className="col-auto ms-auto  pointer add-milestone"><Tooltip title="Add Milestone" className='mt-0'><PlusOutlined className='me-1'> </PlusOutlined></Tooltip>Add Milestone</div>
                            }
                        </div>
                        {
                            <Spin spinning={loading7}>
                                <table className='w-100 proj-temp-table'>
                                    <thead>
                                        <tr className='p-3 parent-head mb-2'>
                                            <th>{selectedOption == 'MileStone'?"Milestone/Task" :"Deliverables"}</th>
                                            <th className=''>Description</th>
                                            <th className='text-center'>Is Mandatory</th>
                                            <th className='text-center'>Status</th>
                                            <th className='text-center'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {mileData?.map((item,i) =>{ 
                                            return(
                                                <React.Fragment key={item.mileStoneID}>
                                                <tr  className={`border-bottom  parent-body ${getParentTableClassName(item.mileStoneID)} ${openSubMenu === item.mileStoneID ? 'child-open' : ''}`}  >
                                                    <td className='selected' style={{ width: '30%' }} onClick={() => toggleSubMenu(item.mileStoneID)}> 
                                                            {(openSubMenu !== item.mileStoneID) ? (
                                                            <DownOutlined className='me-2 pointer' onClick={() => toggleSubMenu(item.mileStoneID)} />
                                                            ) :  (
                                                            <UpOutlined className='me-2 pointer' onClick={() => toggleSubMenu(item.mileStoneID)} />
                                                            ) }
                                                        {item.mileStoneName}</td>
                                                    <td className=' selected ps-4' style={{ width: '35%' }} onClick={() => toggleSubMenu(item.mileStoneID)}>{item.description}</td>
                                                    <td className='text-center pointer' style={{ width: '10%' }} onClick={() => toggleSubMenu(item.mileStoneID)} >{item.isMandatory == false ?"No":"Yes"} </td>
                                                    <td className='text-center pointer' style={{ width: '10%' }} onClick={() => toggleSubMenu(item.mileStoneID)} >{item.mileStoneStatus} </td>
                                                    <td className='text-center pointer' >
                                                    {
                                                        selectedOption == 'MileStone' && 
                                                        <span className='pe-2'>
                                                            <Tooltip title="Edit Milestone" className='mt-0'>
                                                                <EditFilled className='me-1' onClick={() => updateMilestoneDrawer(item)} />
                                                            </Tooltip>
                                                        </span>
                                                    }
                                                        <span className=' pe-2'>
                                                            <Tooltip title={selectedOption === "MileStone"? "Add Task" : "Add Deliverable"} className='mt-0'>
                                                                <FileAddOutlined className='me-1 AddIcon' 
                                                                onClick={() =>{
                                                                    if (selectedOption === "MileStone") {
                                                                        openTaskDrawer(item.startDate, item.endDate, item.mileStoneID)
                                                                    }
                                                                    else{
                                                                        setMilestoneID(item.mileStoneID);
                                                                        openDeliverableDrawer();
                                                                    }
                                                                } }
                                                                /> 
                                                            </Tooltip>
                                                        </span>
                                                    {
                                                        selectedOption == 'MileStone' && 
                                                        <span className=' ' >
                                                            <Popconfirm
                                                                description={(item.projectTaskList.length != 0 &&item.isMandatory) ?<>"Are you sure you want to delete this milestone<br/> with associated tasks?"</>:"Are you sure to delete this Milestone?" }
                                                                onConfirm={()=>deletePrjMilestone(item)}
                                                                okText="Yes"
                                                                cancelText="No"
                                                                >
                                                                <span> <Tooltip title="Delete Milestone" className='mt-0'><DeleteOutlined className='me-1 text-danger' /></Tooltip></span>
                                                            </Popconfirm>
                                                        </span>
                                                    }
                                                    </td>
                                                </tr>
                                                {
                                                    openSubMenu === item.mileStoneID && selectedOption == 'MileStone' && (

                                                    <tr className='child-container task'>
                                                        {
                                                            item.projectTaskList.length != 0 ? 
                                                                <td colSpan="5" className={`${openSubMenu === item.mileStoneID ? 'child-open' : ''} border-top-0`}>
                                                                    <table className='sub-table w-100'>
                                    
                                                                        <thead>
                                                                            <tr className='child-head'>
                                                                                <th style={{width:'28.5%'}}>Tasks:</th>
                                                                                <th className='' style={{width:'36%'}}>Description</th>
                                                                                <th className='text-center' style={{width:'10.2%'}} >Priority</th>
                                                                                <th className='text-center' style={{width:'10.2%'}}>Status</th>
                                                                                <th className='text-center'>Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody className='w-100'>
                                                                            {item.projectTaskList?.map((sub2,i) =>{
                                                                                return(
                                                                                    <tr key={sub2.pTaskID} className='child-body'>
                                                                                        <td >{sub2.taskName}</td>
                                                                                        <td className=''>{sub2.taskDescription}</td>
                                                                                        <td className='text-center ps-0'>{sub2.taskPriority}</td>
                                                                                        <td className='text-center ps-0'>{sub2.taskStatus}</td>
                                                                                        <td className='text-center pointer pe-2'>
                                                                                            <span className='pe-2 '>
                                                                                                <Tooltip title="Edit Task" className='mt-0'>
                                                                                                    <EditFilled className='me-1' onClick={() =>{ getTask(sub2); updateTaskDrawer(sub2, item.startDate, item.endDate) }}/>
                                                                                                </Tooltip>
                                                                                            </span>
                                                                                            <span className=' ' >
                                                                                                <Popconfirm
                                                                                                description="Are you sure to delete this Task?"
                                                                                                onConfirm={() =>  deletePrjtask(sub2)}
                                                                                                okText="Yes"
                                                                                                cancelText="No"
                                                                                                >
                                                                                                <span><Tooltip title="Delete Task" className='mt-0'><DeleteOutlined className='me-1 text-danger' /> </Tooltip></span> 
                                                                                                </Popconfirm>
                                                                                            </span>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                                : <td colSpan="5" className={`${openSubMenu === item.mileStoneID ? 'child-open' : ''} text-center`}> No Task are associated</td>
                                                        }
                                                        </tr>
                                                    )
                                                }
                                                {
                                                    openSubMenu === item.mileStoneID  && selectedOption == 'Deliverable' && (
                                                    <tr  className='child-container Deliverable'>
                                                        {
                                                            item.projectDeliverableList.length !== 0 ?
                                                                <td colSpan="5" className={`${openSubMenu === item.mileStoneID ? 'child-open' : ''}`}>
                                                                    <table className='sub-table w-100'>
                                                                        <thead>
                                                                            <tr className='child-head'>
                                                                                <th style={{width:'28.5%'}}>Deliverable Type:</th>
                                                                                <th className='' style={{width:'36%'}}>Description</th>
                                                                                <th className='text-center' style={{width:'10.2%'}} >Is Mandatory</th>
                                                                                <th className='text-center' style={{width:'10.2%'}} >Deliverable Type</th>
                                                                                <th className='text-center'> Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody className='w-100'>
                                                                            {item.projectDeliverableList?.map((sub3,i) =>{
                                                                                return(
                                                                                        <tr key={sub3.deliverableTypeID} className='child-body'>
                                                                                            <td >{sub3.deliverableType}</td>
                                                                                            <td className=''>{sub3.description}</td>
                                                                                            <td className='text-center ps-0'>{sub3.isMandatory== false ?"No":"Yes"}</td>
                                                                                            <td className='text-center ps-0'>{sub3.documentType? sub3.documentType: '-'}</td>
                                                                                            <td className='text-center pointer'>
                                                                                                <span className='pe-2 '>
                                                                                                    <Tooltip title="Edit Deliverable" className='mt-0'>
                                                                                                        <EditFilled className='me-1' onClick={() => {getDeliverable(sub3); updateDeliverableDrawer(sub3)}}/>
                                                                                                    </Tooltip>
                                                                                                </span>
                                                                                                <span className=' ' >
                                                                                                    <Popconfirm
                                                                                                    description="Are you sure to delete this Deliverable?"
                                                                                                    onConfirm={() =>  deletePrjDeliverable(sub3)}
                                                                                                    okText="Yes"
                                                                                                    cancelText="No"
                                                                                                    >
                                                                                                    <span><Tooltip title="Delete Deliverable" className='mt-0'><DeleteOutlined className='me-1 text-danger' /></Tooltip></span>
                                                                                                    </Popconfirm>
                                                                                                </span>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })}
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            :   <td colSpan="5" className={`${openSubMenu === item.mileStoneID ? 'child-open' : ''} text-center`}> No Deliverable are associated</td>
                                                        }
                                                    </tr>
                                                    )
                                                }
                                                </React.Fragment>
                                            )
                                        }
                                        ) 
                                        }
                                        {
                                            mileData.length == 0 ?
                                            <tr>
                                                <td colSpan="5" className= 'text-center'> No Milestone are associated</td>
                                            </tr>
                                            : ""
                                        }
                                    </tbody>
                                </table>
                            </Spin>
                         }
                         <AddSettings data={{
                            title: "Add/Update Project Type", isOpen: projectTypeDrawer, id: 2, drawerCallbackFunc: drawerCallbackFunc,
                            tenantID: props.data.tenantID, appUserID: props.data.appUserID, locationID: props.data.locationID,rowData:typeList?.data[0],callbackFunc: props.data.callbackFunc
                            }} />
                         <Drawer title="Add/Update Milestone" className='TemplateDrawer' width={550} placement="right" onClose={hanldeCloseDrawer} open={openDrawer}>
                            <Form
                                form={form}
                                onFinish={onSubmitForm}
                                layout="vertical">
                                <Form.Item label="Milestone Name" name="milestoneName" className='col right-col'
                                    rules={[{ required: true, message: "This field is required" }]}>
                                    <TextArea />
                                </Form.Item>
                                <Form.Item label="Description" name="description" className='col right-col'>
                                    <TextArea rows={3} />
                                </Form.Item>
                                <Form.Item label="" name="isMandatoryMil" valuePropName="checked">
                                    <Checkbox>Is Mandatory?</Checkbox>
                                </Form.Item>
                                <Form.Item label="Status" name="status" className='col right-col'
                                    rules={[{ required: true, message: "This field is required" }]}>
                                    <Select options={taskStatusOptions} disabled={milestoneID == 0} />
                                </Form.Item>
                                <div className='row m-0 text-end'>
                                    <Button className="dlv-cancel-btn me-1" type="primary ms-auto cancel-btn" danger onClick={hanldeCloseDrawer}>Cancel</Button>
                                    <Button className='dlv-save-btn ms-1' type="primary save-btn ms-1" htmlType='submit' loading={loading10}>Save</Button>
                                </div>
                            </Form>
                        </Drawer>
                        <Drawer title="Add/Update Deliverables Details" className='TemplateDrawer' width={550} placement="right" onClose={hanldeCloseDeliverableDrawer}
                         open={deliverableDrawer}
                         closable={false}
                         >
                            <Form
                                form={form2}
                                onFinish={savePrjDeliverable}
                                layout="vertical">
                                <Form.Item label="Deliverable Name" name="deliverableName" className='col right-col'
                                    rules={[{ required: true, message: "This field is required" }]}>
                                    <TextArea />
                                </Form.Item>
                                <Form.Item label="Description" name="description" className='col right-col'>
                                    <TextArea rows={3} />
                                </Form.Item>
                                <Form.Item label="" name="isMandatory" valuePropName="checked">
                                    <Checkbox className="mandatoryCheck">Is Mandatory?</Checkbox>
                                </Form.Item>
                                <Form.Item label="" name="isDoc" valuePropName="checked">
                                    <Checkbox onChange={handleIsDoc} >Is Document?</Checkbox>
                                </Form.Item>
                                {
                                    isDoc  &&
                                    <Form.Item label="Document Type" name="docType"
                                        rules={[
                                            {
                                                required: true,
                                                message: "This field is required"
                                            }
                                        ]}>
                                        <Select  options={documentTypeList} />
                                    </Form.Item>
                                }
                                <div className='col m-0 text-end'>
                                    <Button type=" dlv-cancel-btn me-1" danger onClick={hanldeCloseDeliverableDrawer}>Cancel</Button>
                                    <Button type=" dlv-save-btn ms-1 " htmlType='submit' loading={loading11}>Save</Button>
                                </div>
                            </Form>
                        </Drawer>

                        <Drawer title="Add/Update Task" className='TemplateDrawer'  width={550} placement="right" onClose={hanldeCloseTaskDrawer} open={taskDrawer}>
                            <Form
                                form={form1}
                                onFinish={saveProjecTask}
                                layout="vertical">
                                <div className='row m-0'>
                                    <Form.Item label="Task Name" name="taskName" className='col '
                                        rules={[{ required: true, message: "This field is required" }]}>
                                        <Input />
                                    </Form.Item>
                                    
                                </div>
                                <div className='row m-0'>
                                    <Form.Item label="Priority" name="priority" className='col'
                                        rules={[{ required: true, message: "This field is required" }]}
                                    >
                                        <Select options={priorityOptions} />
                                    </Form.Item>
                                    <Form.Item label="Status" name="taskStatus" className='col right-col'
                                        rules={[{ required: true, message: "This field is required" }]}>
                                        <Select options={taskStatusOptions} disabled={taskID == 0} />
                                    </Form.Item>
                                </div>
                                <Form.Item label="Description" name="description" className='col right-col'>
                                    <TextArea rows={3} />
                                </Form.Item>
                                <div className='row m-0 text-end'>
                                    <Button className="dlv-cancel-btn me-1" type="primary ms-auto cancel-btn" danger onClick={hanldeCloseTaskDrawer}>Cancel</Button>
                                    <Button className='dlv-save-btn ms-1' type="primary save-btn ms-1" htmlType='submit' loading={loading9}>Save</Button>
                                </div>
                            </Form>
                        </Drawer>
                    </div>
                </div>
            </div>
        </div>
    )
}